import { CdkDrag } from '@angular/cdk/drag-drop';
import { afterNextRender, computed, effect, ElementRef, inject, Injector, signal, untracked, viewChild, } from '@angular/core';
import { AGENT_FEATURE, GUIDED_WORKFLOWS_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
import { SECURITY_ID_REGEX_SOURCE } from 'SecuritiesApp/ts/constants/security-ids.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { AgentSidePanelStateService } from 'AgentApp/ts/services/agent-side-panel-state.service';
import { AgentUserPreferencesService } from 'AgentApp/ts/services/agent-user-preferences.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { GuidedWorkflowsService } from 'GuidedWorkflowsApp/ts/services/guided-workflows.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { CookieService } from 'ngx-cookie-service';
import { BackgroundJobService } from 'NotificationsApp/ts/services/background-job.service';
import { BackgroundJobEventsService } from 'NotificationsApp/ts/services/background-job-events.service';
import { NotificationsService } from 'NotificationsApp/ts/services/notifications.service';
// Components
import { GuidedWorkflowsMenuComponent } from 'GuidedWorkflowsApp/ts/features/guided-workflows-menu/components/guided-workflows-menu.component';
import { BackgroundJobsProgressPopoverComponent } from 'NotificationsApp/ts/features/background-jobs-progress-popover/components/background-jobs-progress-popover/background-jobs-progress-popover.component';
import { NotificationsSideMenuComponent } from 'NotificationsApp/ts/features/notifications-side-menu/components/notifications-side-menu/notifications-side-menu.component';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "ngx-cookie-service";
import * as i4 from "GuidedWorkflowsApp/ts/services/guided-workflows.service";
import * as i5 from "NotificationsApp/ts/services/notifications.service";
import * as i6 from "NotificationsApp/ts/services/background-job-events.service";
import * as i7 from "NotificationsApp/ts/services/background-job.service";
import * as i8 from "AccountsApp/ts/services/accounts.service";
import * as i9 from "@angular/common";
import * as i10 from "QuickflowsApp/ts/features/quickflows-menu/components/quickflows-menu.component";
import * as i11 from "../../../../../../apps/guided_workflows/static/guided_workflows/ts/features/guided-workflows-menu/components/guided-workflows-menu.component";
import * as i12 from "../../directives/icon/icon.directive";
import * as i13 from "../../directives/popovers/tooltip/tooltip.directive";
import * as i14 from "../../../../../../apps/agent/static/agent/ts/features/agent/components/agent-side-panel/agent-side-panel.component";
import * as i15 from "@angular/cdk/drag-drop";
import * as i16 from "NotificationsApp/ts/features/notifications-side-menu/components/notifications-side-menu/notifications-side-menu.component";
import * as i17 from "NotificationsApp/ts/features/background-jobs-progress-popover/components/background-jobs-progress-popover/background-jobs-progress-popover.component";
const _c0 = a0 => ({ "d-none": a0 });
const _c1 = a0 => ({ "side-menu-opened": a0 });
function SideMenuComponent_Conditional_0_Conditional_8_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 10);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-notifications-color");
} }
function SideMenuComponent_Conditional_0_Conditional_8_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 11);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-notifications");
} }
function SideMenuComponent_Conditional_0_Conditional_8_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "div", 14);
    i0.ɵɵelementEnd();
} }
function SideMenuComponent_Conditional_0_Conditional_8_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.notifications().length);
} }
function SideMenuComponent_Conditional_0_Conditional_8_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1, "20+");
    i0.ɵɵelementEnd();
} }
function SideMenuComponent_Conditional_0_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 9);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("notifications")); });
    i0.ɵɵconditionalCreate(2, SideMenuComponent_Conditional_0_Conditional_8_Conditional_2_Template, 1, 1, ":svg:svg", 10)(3, SideMenuComponent_Conditional_0_Conditional_8_Conditional_3_Template, 1, 1, ":svg:svg", 11);
    i0.ɵɵconditionalCreate(4, SideMenuComponent_Conditional_0_Conditional_8_Conditional_4_Template, 2, 0, "div", 12)(5, SideMenuComponent_Conditional_0_Conditional_8_Conditional_5_Template, 2, 1, "div", 13)(6, SideMenuComponent_Conditional_0_Conditional_8_Conditional_6_Template, 2, 0, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isNotificationsActive());
    i0.ɵɵproperty("tooltipTitle", "Notifications")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isNotificationsActive() ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.notifications().length === 0 && ctx_r1.hasRunningJobs() ? 4 : ctx_r1.notifications().length > 0 && ctx_r1.notifications().length < 20 ? 5 : ctx_r1.notifications().length >= 20 ? 6 : -1);
} }
function SideMenuComponent_Conditional_0_Conditional_9_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 10);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-ai-agent-color");
} }
function SideMenuComponent_Conditional_0_Conditional_9_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 11);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-ai-agent");
} }
function SideMenuComponent_Conditional_0_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 15);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.handleAgentLink()); });
    i0.ɵɵconditionalCreate(2, SideMenuComponent_Conditional_0_Conditional_9_Conditional_2_Template, 1, 1, ":svg:svg", 10)(3, SideMenuComponent_Conditional_0_Conditional_9_Conditional_3_Template, 1, 1, ":svg:svg", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isAIAgentActive());
    i0.ɵɵproperty("tooltipTitle", "Y - AI Agent")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isAIAgentActive() ? 2 : 3);
} }
function SideMenuComponent_Conditional_0_Conditional_10_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 10);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-quickflows-color");
} }
function SideMenuComponent_Conditional_0_Conditional_10_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 11);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-quickflows");
} }
function SideMenuComponent_Conditional_0_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 16);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("quickflows")); });
    i0.ɵɵconditionalCreate(2, SideMenuComponent_Conditional_0_Conditional_10_Conditional_2_Template, 1, 1, ":svg:svg", 10)(3, SideMenuComponent_Conditional_0_Conditional_10_Conditional_3_Template, 1, 1, ":svg:svg", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isQuickflowsActive());
    i0.ɵɵproperty("tooltipTitle", "Quickflows")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isQuickflowsActive() ? 2 : 3);
} }
function SideMenuComponent_Conditional_0_Conditional_11_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 10);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-workflows-color");
} }
function SideMenuComponent_Conditional_0_Conditional_11_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 11);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-workflows");
} }
function SideMenuComponent_Conditional_0_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 17);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("workflows")); });
    i0.ɵɵconditionalCreate(2, SideMenuComponent_Conditional_0_Conditional_11_Conditional_2_Template, 1, 1, ":svg:svg", 10)(3, SideMenuComponent_Conditional_0_Conditional_11_Conditional_3_Template, 1, 1, ":svg:svg", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isWorkflowsActive());
    i0.ɵɵproperty("tooltipTitle", "Workflows")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isWorkflowsActive() ? 2 : 3);
} }
function SideMenuComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4);
    i0.ɵɵelement(4, "ycn-background-jobs-progress-popover", 5);
    i0.ɵɵelementStart(5, "div", 6)(6, "button", 7);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 2);
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(8, SideMenuComponent_Conditional_0_Conditional_8_Template, 7, 7, "div", 8);
    i0.ɵɵconditionalCreate(9, SideMenuComponent_Conditional_0_Conditional_9_Template, 4, 6, "div", 8);
    i0.ɵɵconditionalCreate(10, SideMenuComponent_Conditional_0_Conditional_10_Template, 4, 6, "div", 8);
    i0.ɵɵconditionalCreate(11, SideMenuComponent_Conditional_0_Conditional_11_Template, 4, 6, "div", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0, ctx_r1.isMenuOpen))("tooltipTitle", "Open Menu")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close-arrow");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c1, ctx_r1.isMenuOpen));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jobsInProgress", ctx_r1.runningJobs());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", "Close")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showNotifications ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAgentButton() ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showQuickflows ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.categories.length > 0 && ctx_r1.showWorkflows ? 11 : -1);
} }
function SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.openBackgroundJobsProgressPopover()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "In Progress Items")("tooltipPlacement", "right");
} }
function SideMenuComponent_Conditional_1_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 28);
    i0.ɵɵtext(2, "Notifications");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template, 1, 2, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 30)(5, "a", 31);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_3_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.deleteAllNotifications()); });
    i0.ɵɵtext(6, " Dismiss All ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.hasRunningJobs() ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("disabled", ctx_r1.notifications().length === 0)("text-blue", ctx_r1.notifications().length > 0);
} }
function SideMenuComponent_Conditional_1_Conditional_4_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 35);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_4_Conditional_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.clearSteps()); });
    i0.ɵɵtext(1, "Back to Workflow Categories");
    i0.ɵɵelementEnd();
} }
function SideMenuComponent_Conditional_1_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 28);
    i0.ɵɵtext(2, "Workflows");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, SideMenuComponent_Conditional_1_Conditional_4_Conditional_3_Template, 2, 0, "a", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.workflowsMenuComponent && ctx_r1.workflowsMenuComponent.selectedSteps.length > 0 ? 3 : -1);
} }
function SideMenuComponent_Conditional_1_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 28);
    i0.ɵɵtext(2, "Quickflows");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 36);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", ctx_r1.userPreferencesUrl, i0.ɵɵsanitizeUrl)("tooltipTitle", "Quickflows Preferences");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-gear");
} }
function SideMenuComponent_Conditional_1_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 28);
    i0.ɵɵtext(2, "Y - AI Agent");
    i0.ɵɵelementEnd()();
} }
function SideMenuComponent_Conditional_1_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "a", 37);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "button", 39);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_7_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.toggleDetach()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "button", 40);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_7_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r1.agentPageUrl(), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", ctx_r1.isDetached() ? "Attach Panel" : "Detach Panel");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.isDetached() ? "icon-reattach" : "icon-unattach");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
} }
function SideMenuComponent_Conditional_1_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function SideMenuComponent_Conditional_1_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-quickflows-menu", 24);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("displaySecurityId", ctx_r1.displaySecurityId)("securityId", ctx_r1.securityId)("securityName", ctx_r1.securityName)("securityUrl", ctx_r1.securityUrl);
} }
function SideMenuComponent_Conditional_1_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-guided-workflows-menu", 25);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("pagePath", ctx_r1.pagePath)("categories", ctx_r1.categories)("selectedSubcategoryId", ctx_r1.selectedSubcategoryId);
} }
function SideMenuComponent_Conditional_1_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-side-panel", 26);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isDetached", ctx_r1.isDetached());
} }
function SideMenuComponent_Conditional_1_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-notifications-side-menu", 42);
    i0.ɵɵtwoWayListener("notificationsChange", function SideMenuComponent_Conditional_1_Conditional_12_Template_ycn_notifications_side_menu_notificationsChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.notifications, $event) || (ctx_r1.notifications = $event); return i0.ɵɵresetView($event); })("topSectionPercentageChange", function SideMenuComponent_Conditional_1_Conditional_12_Template_ycn_notifications_side_menu_topSectionPercentageChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.notificationsTopSectionPercentage, $event) || (ctx_r1.notificationsTopSectionPercentage = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtwoWayProperty("notifications", ctx_r1.notifications)("topSectionPercentage", ctx_r1.notificationsTopSectionPercentage);
} }
function SideMenuComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "div", 20);
    i0.ɵɵconditionalCreate(3, SideMenuComponent_Conditional_1_Conditional_3_Template, 8, 5)(4, SideMenuComponent_Conditional_1_Conditional_4_Template, 4, 1, "div")(5, SideMenuComponent_Conditional_1_Conditional_5_Template, 5, 3, "div", 21)(6, SideMenuComponent_Conditional_1_Conditional_6_Template, 3, 0, "div", 21);
    i0.ɵɵconditionalCreate(7, SideMenuComponent_Conditional_1_Conditional_7_Template, 7, 4, "div", 22)(8, SideMenuComponent_Conditional_1_Conditional_8_Template, 2, 1, "button", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(9, SideMenuComponent_Conditional_1_Conditional_9_Template, 1, 4, "ycn-quickflows-menu", 24)(10, SideMenuComponent_Conditional_1_Conditional_10_Template, 1, 3, "ycn-guided-workflows-menu", 25)(11, SideMenuComponent_Conditional_1_Conditional_11_Template, 1, 1, "ycn-agent-side-panel", 26)(12, SideMenuComponent_Conditional_1_Conditional_12_Template, 1, 2, "ycn-notifications-side-menu", 27);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("top", ctx_r1.isDetached() ? null : ctx_r1.sidePanelTop, "px")("width", ctx_r1.isDetached() ? ctx_r1.detachedPanelWidth : null, "px");
    i0.ɵɵclassProp("side-panel-ai", ctx_r1.isAIAgentActive())("detached", ctx_r1.isDetached());
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r1.isDetached());
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("height", ctx_r1.isDetached() ? "100%" : ctx_r1.sidePanelHeight || "calc(-48px + 100dvh)");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("cursor", ctx_r1.isDetached() ? "grab" : null);
    i0.ɵɵclassProp("bg-panel", ctx_r1.isAIAgentActive());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.type() === "notifications" ? 3 : ctx_r1.type() === "workflows" ? 4 : ctx_r1.type() === "quickflows" ? 5 : ctx_r1.type() === "ai_agent" ? 6 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.isAIAgentActive() ? 7 : 8);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.type() === "quickflows" ? 9 : ctx_r1.type() === "workflows" ? 10 : ctx_r1.type() === "ai_agent" ? 11 : ctx_r1.type() === "notifications" ? 12 : -1);
} }
export class SideMenuComponent {
    onScrollEvent() {
        const sidePanel = this.eltRef.nativeElement.querySelector('.side-panel.open');
        if (sidePanel && window.getComputedStyle(sidePanel).position === 'fixed') {
            this.sidePanelTop = Math.max(0, this.headerHeight - window.scrollY);
        }
        else {
            this.sidePanelTop = undefined;
        }
        this.sidePanelHeight =
            window.scrollY < this.headerHeight ? `calc(100vh - ${this.headerHeight - window.scrollY}px)` : '100vh';
    }
    constructor(eltRef, injector, urlsService, featureService, cookieService, guidedWorkflowsService, notificationsService, backgroundJobEventsService, backgroundJobService, accountsService) {
        this.eltRef = eltRef;
        this.injector = injector;
        this.urlsService = urlsService;
        this.featureService = featureService;
        this.cookieService = cookieService;
        this.guidedWorkflowsService = guidedWorkflowsService;
        this.notificationsService = notificationsService;
        this.backgroundJobEventsService = backgroundJobEventsService;
        this.backgroundJobService = backgroundJobService;
        this.accountsService = accountsService;
        this._agentSidepanelStateService = inject(AgentSidePanelStateService);
        this._agentUserPreferencesService = inject(AgentUserPreferencesService);
        this.showQuickflows = true;
        this.showNotifications = true;
        this.cdkDrag = viewChild(CdkDrag, ...(ngDevMode ? [{ debugName: "cdkDrag" }] : []));
        this.isSidePanelOpen = signal(false, ...(ngDevMode ? [{ debugName: "isSidePanelOpen" }] : []));
        this.prefsLoaded = signal(false, ...(ngDevMode ? [{ debugName: "prefsLoaded" }] : []));
        this.isMenuOpen = true;
        this.type = signal('quickflows', ...(ngDevMode ? [{ debugName: "type" }] : []));
        this.userPreferencesUrl = '';
        this.showWorkflows = false;
        this.categories = [];
        this.notifications = signal([], ...(ngDevMode ? [{ debugName: "notifications" }] : []));
        this.selectedSubcategoryId = null;
        this.headerHeight = 48;
        this.notificationsTopSectionPercentage = signal(65, ...(ngDevMode ? [{ debugName: "notificationsTopSectionPercentage" }] : []));
        this.alwaysShowJobsProgressPopover = true;
        this.MODEL_PORTFOLIO_QUICK_EXTRACT_JOB_TYPE = 'model_portfolio_quick_extract';
        this._isPanelDetached = signal(false, ...(ngDevMode ? [{ debugName: "_isPanelDetached" }] : []));
        this.isDetached = computed(() => {
            const type = this.type();
            const isDetached = this._isPanelDetached();
            return type === 'ai_agent' && isDetached;
        }, ...(ngDevMode ? [{ debugName: "isDetached" }] : []));
        this.savedDragPosition = signal({ x: 0, y: 0 }, ...(ngDevMode ? [{ debugName: "savedDragPosition" }] : []));
        this.detachedPanelWidth = 586;
        this.USER = signal(window.USER, ...(ngDevMode ? [{ debugName: "USER" }] : []));
        this.agentPageUrl = computed(() => {
            const agentSidePanelSessionId = this._agentSidepanelStateService.currentSessionId();
            return `/agent/#/${agentSidePanelSessionId ? `?agentSessionId=${agentSidePanelSessionId}` : ''}`;
        }, ...(ngDevMode ? [{ debugName: "agentPageUrl" }] : []));
        this.showAgentButton = computed(() => {
            const isOnAgentPage = this.isOnAgentPage();
            return !isOnAgentPage;
        }, ...(ngDevMode ? [{ debugName: "showAgentButton" }] : []));
        // TODO: Remove once notifications in side menu is fully released: https://app.asana.com/1/1144271657183267/project/1213220632434778/task/1213763386011560
        this.showNotificationsButton = computed(() => {
            const user = this.USER();
            return user.isStaff;
        }, ...(ngDevMode ? [{ debugName: "showNotificationsButton" }] : []));
        this.isNotificationsActive = computed(() => {
            const isSidePanelOpen = this.isSidePanelOpen();
            const type = this.type();
            return isSidePanelOpen && type === 'notifications';
        }, ...(ngDevMode ? [{ debugName: "isNotificationsActive" }] : []));
        this.isAIAgentActive = computed(() => {
            const isSidePanelOpen = this.isSidePanelOpen();
            const type = this.type();
            return isSidePanelOpen && type === 'ai_agent';
        }, ...(ngDevMode ? [{ debugName: "isAIAgentActive" }] : []));
        this.isQuickflowsActive = computed(() => {
            const isSidePanelOpen = this.isSidePanelOpen();
            const type = this.type();
            return isSidePanelOpen && type === 'quickflows';
        }, ...(ngDevMode ? [{ debugName: "isQuickflowsActive" }] : []));
        this.isWorkflowsActive = computed(() => {
            const isSidePanelOpen = this.isSidePanelOpen();
            const type = this.type();
            return isSidePanelOpen && type === 'workflows';
        }, ...(ngDevMode ? [{ debugName: "isWorkflowsActive" }] : []));
        this.isOnAgentPage = signal(false, ...(ngDevMode ? [{ debugName: "isOnAgentPage" }] : []));
        this.userHasAgentFeature = this.USER().features.includes(AGENT_FEATURE);
        this.hasRunningJobs = computed(() => Object.keys(this.backgroundJobEventsService.jobsInProgress()).length > 0, ...(ngDevMode ? [{ debugName: "hasRunningJobs" }] : []));
        this.hasRunningQuickExtractJob = computed(() => Object.values(this.backgroundJobEventsService.jobsInProgress()).some((job) => job.job_type === this.MODEL_PORTFOLIO_QUICK_EXTRACT_JOB_TYPE), ...(ngDevMode ? [{ debugName: "hasRunningQuickExtractJob" }] : []));
        this.runningJobs = computed(() => this.backgroundJobEventsService.jobsInProgress(), ...(ngDevMode ? [{ debugName: "runningJobs" }] : []));
        this.isOnAgentPage.set(window.location?.pathname?.startsWith('/agent') ?? false);
        this.displaySecurityId = this.eltRef.nativeElement.getAttribute('displaySecurityId');
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityUrl = this.eltRef.nativeElement.getAttribute('securityUrl');
        this.showQuickflows = JSON.parse(this.eltRef.nativeElement.getAttribute('showQuickflows')) ?? true;
        this.showNotifications = JSON.parse(this.eltRef.nativeElement.getAttribute('showNotifications')) ?? true;
        this.pagePath = this.eltRef.nativeElement.getAttribute('pagePath');
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.notificationsTopSectionPercentage.set(Math.min(85, Math.max(15, preference.side_menu_top_section_percentage)));
            this.alwaysShowJobsProgressPopover = preference.always_display_jobs_progress_popover;
            if (this.USER().authenticated && this.showNotifications) {
                // Only listen for running jobs after determining if we should open the popover
                // to avoid opening it prematurely.
                this.listenForRunningJobs();
            }
            if (preference.agent_side_panel_open_on_load &&
                this.USER().features.includes('agent') &&
                !this.isOnAgentPage() &&
                !this.hasGuidedWorkflowQueryParam()) {
                this.type.set('ai_agent');
                this.isSidePanelOpen.set(true);
                afterNextRender(() => this.onScrollEvent(), { injector: this.injector });
            }
            this.prefsLoaded.set(true);
        });
        effect(() => {
            const cdkDrag = this.cdkDrag();
            const isDetached = this.isDetached();
            if (cdkDrag && isDetached) {
                const position = untracked(() => this.savedDragPosition());
                position.x = position.x || window.innerWidth - this.detachedPanelWidth - 100;
                cdkDrag.setFreeDragPosition(position);
            }
        });
        effect(() => {
            const hasRunningJobs = this.hasRunningJobs();
            const hasRunningQuickExtractJob = this.hasRunningQuickExtractJob();
            const popover = this.backgroundJobsProgressPopover;
            if (!hasRunningJobs && popover?.isOpen) {
                // Always close the running jobs popover if no more jobs are running
                popover.closeModal();
            }
            if (hasRunningJobs && popover && !popover.isOpen) {
                if (this.alwaysShowJobsProgressPopover) {
                    // Open the running jobs popover if a job starts running.
                    // TODO: Add check to verify the user doesn't have the `show_jobs_progress_popover` set to false.
                    this.openBackgroundJobsProgressPopover();
                }
                else if (hasRunningQuickExtractJob) {
                    // Quick extract uploads always surface the progress popover so the running extraction
                    // is visible, even when the user has dismissed it for other job types. Open it directly
                    // without flipping their global `always_display_jobs_progress_popover` preference.
                    popover.openModal();
                }
            }
        });
        effect(() => {
            const terminalJob = this.backgroundJobEventsService.lastTerminalJob();
            if (terminalJob && terminalJob.status === 'completed') {
                this.fetchNotifications();
            }
        });
    }
    ngOnInit() {
        this.userPreferencesUrl = this.urlsService.ACCOUNTS.QUICKFLOWS;
        const hasGuidedWorkflowsFeature = this.featureService.userHasFeatures([GUIDED_WORKFLOWS_FEATURE]);
        const subcategoryCookie = this.cookieService.get(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME) || '""';
        const subcategorySelectedId = JSON.parse(decodeURIComponent(subcategoryCookie));
        const unhashedLocation = window.location.toString().replace('/#/', '/');
        const newURL = new URL(unhashedLocation);
        const queryParams = new URLSearchParams(newURL.search);
        const guidedWorkFlow = queryParams.get('gw');
        const querySubcategoryId = guidedWorkFlow == null || Number.isNaN(guidedWorkFlow) ? null : Number(guidedWorkFlow);
        if (this.pagePath === undefined || this.pagePath === null) {
            this.pagePath = this.getPathName(window.location.pathname);
        }
        this.showWorkflows = hasGuidedWorkflowsFeature;
        if (this.pagePath) {
            this.guidedWorkflowsService.getPageGuidedWorkflows(this.pagePath).subscribe((categories) => {
                this.categories = categories;
                const allSubcategories = categories.reduce((accumulator, category) => accumulator.concat(category.subcategories), []);
                const selectedCategoryId = querySubcategoryId !== null ? querySubcategoryId : subcategorySelectedId;
                this.selectedSubcategoryId =
                    allSubcategories.find((subcategory) => subcategory.id === selectedCategoryId)?.id ?? null;
                if (this.selectedSubcategoryId !== null && !this.isSidePanelOpen()) {
                    this.togglePanel('workflows');
                }
            });
        }
        if (this.USER().authenticated && this.showNotifications) {
            this.fetchNotifications();
        }
    }
    ngOnDestroy() {
        this.backgroundJobEventsService.closeStream();
    }
    setJobsInProgress(background_jobs) {
        const jobs = background_jobs.map(({ children: _, ...job }) => job);
        const jobsMap = Object.fromEntries(jobs.map((job) => [job.job_id, job]));
        this.backgroundJobEventsService.jobsInProgress.set(jobsMap);
    }
    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }
    handleAgentLink() {
        if (this.userHasAgentFeature) {
            this.togglePanel('ai_agent');
        }
        else if (this.USER().authenticated) {
            window.open(this.agentPageUrl(), '_blank');
        }
        else {
            window.location.href = this.agentPageUrl();
        }
    }
    togglePanel(type) {
        if (this.isSidePanelOpen() && this.type() === 'ai_agent') {
            this.saveDragState();
            if (this.isDetached()) {
                const drag = this.cdkDrag();
                if (drag) {
                    drag.reset();
                }
            }
        }
        if (this.isSidePanelOpen() && this.type() !== type) {
            // Panel is already open with a different type — just switch to the new type
            this.type.set(type);
        }
        else {
            // Panel is closed (open it) or same type clicked (close it)
            this.type.set(type);
            this.isSidePanelOpen.update((isOpen) => !isOpen);
            if (!this.isSidePanelOpen()) {
                this.clearGuidedWorkflowsSubcategoryCookie();
            }
        }
        // Make sure side panel top and height are set correctly after open
        if (this.isSidePanelOpen()) {
            afterNextRender(() => this.onScrollEvent(), { injector: this.injector });
        }
        if (this.type() === 'ai_agent') {
            this.syncAgentPanelPref();
        }
    }
    syncAgentPanelPref() {
        // gate on prefs being loaded to fix race condition
        if (this.isOnAgentPage() || !this.prefsLoaded()) {
            return;
        }
        const isAgentVisible = this.isSidePanelOpen() && this.type() === 'ai_agent';
        this._agentUserPreferencesService
            .save({ agent_side_panel_open_on_load: isAgentVisible })
            .subscribe({ error: () => { } });
    }
    fetchNotifications() {
        this.notificationsService.getNotifications().subscribe({
            next: (notifications) => {
                this.notifications.set(notifications);
            },
            error: () => { },
        });
    }
    deleteAllNotifications() {
        if (!this.notifications().length || !this.notificationsSideMenuComponent) {
            return;
        }
        this.notificationsSideMenuComponent.deleteAllNotifications();
    }
    closeMenu() {
        if (this.type() === 'ai_agent') {
            this.saveDragState();
        }
        this.isSidePanelOpen.set(false);
        this.clearGuidedWorkflowsSubcategoryCookie();
        if (this.type() === 'ai_agent') {
            this.syncAgentPanelPref();
        }
    }
    clearSteps() {
        this.workflowsMenuComponent.clearSteps();
    }
    hasGuidedWorkflowQueryParam() {
        const unhashedLocation = window.location.toString().replace('/#/', '/');
        const gw = new URL(unhashedLocation).searchParams.get('gw');
        return gw !== null && !Number.isNaN(Number(gw));
    }
    getPathName(pathname) {
        // Indicators don't use exchange symbols in URLs, but their name in snake case
        const indicatorsIdRegexSource = `(?!indicators(?:/|$))[a-z0-9_]+`;
        // We want to match only if after the ID there is either a slash or the end of the string.
        const securityIdRegex = pathname.includes('/indicators/')
            ? new RegExp(`/(?:${SECURITY_ID_REGEX_SOURCE}|${indicatorsIdRegexSource})(/|$)`)
            : new RegExp(`/(?:${SECURITY_ID_REGEX_SOURCE})(/|$)`);
        const decodeUriUntilStable = (str) => {
            let lastDecodedStr = str;
            try {
                let currDecodedStr = decodeURIComponent(str);
                // Iterate until decoding no longer changes the string
                while (currDecodedStr !== lastDecodedStr) {
                    lastDecodedStr = currDecodedStr;
                    currDecodedStr = decodeURIComponent(lastDecodedStr);
                }
                return lastDecodedStr;
            }
            catch {
                // If decoding fails for any reason, just return the last successfully decoded string
                return lastDecodedStr;
            }
        };
        // Pathname may be double-url-encoded, so we decode until it doesn't change. If it wasn't double-url-encoded, or
        // even single-url-encoded, decoding multiple times won't hurt.
        const decodedPathname = decodeUriUntilStable(pathname);
        return decodedPathname.replace(securityIdRegex, '/0/').replace(/^\//, '').replace(/\/$/, '');
    }
    toggleDetach() {
        const reattaching = this._isPanelDetached();
        if (reattaching) {
            this.saveDragState();
            const drag = this.cdkDrag();
            if (drag) {
                drag.reset();
            }
        }
        this._isPanelDetached.update((x) => !x);
    }
    saveDragState() {
        const pos = this.cdkDrag()?.getFreeDragPosition();
        if (pos) {
            this.savedDragPosition.set(pos);
        }
    }
    clearGuidedWorkflowsSubcategoryCookie() {
        this.cookieService.delete(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME, '/');
    }
    openBackgroundJobsProgressPopover() {
        this.accountsService.putUserPreferences({ always_display_jobs_progress_popover: true }).subscribe();
        this.backgroundJobsProgressPopover.openModal();
    }
    listenForRunningJobs() {
        this.backgroundJobService.fetchJobsInProgress().subscribe({
            next: (data) => {
                this.setJobsInProgress(data.background_jobs);
            },
            error: () => { },
        });
        if (!this.backgroundJobEventsService.isConnected()) {
            this.backgroundJobEventsService.stream();
        }
    }
}
SideMenuComponent.ɵfac = function SideMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.CookieService), i0.ɵɵdirectiveInject(i4.GuidedWorkflowsService), i0.ɵɵdirectiveInject(i5.NotificationsService), i0.ɵɵdirectiveInject(i6.BackgroundJobEventsService), i0.ɵɵdirectiveInject(i7.BackgroundJobService), i0.ɵɵdirectiveInject(i8.AccountsService)); };
SideMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SideMenuComponent, selectors: [["ycn-side-menu"]], viewQuery: function SideMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.cdkDrag, CdkDrag, 5);
        i0.ɵɵviewQuery(GuidedWorkflowsMenuComponent, 5);
        i0.ɵɵviewQuery(NotificationsSideMenuComponent, 5);
        i0.ɵɵviewQuery(BackgroundJobsProgressPopoverComponent, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.workflowsMenuComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.notificationsSideMenuComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.backgroundJobsProgressPopover = _t.first);
    } }, hostBindings: function SideMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function SideMenuComponent_scroll_HostBindingHandler($event) { return ctx.onScrollEvent($event); }, i0.ɵɵresolveWindow);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl", showQuickflows: "showQuickflows", showNotifications: "showNotifications", pagePath: "pagePath" }, standalone: false, decls: 2, vars: 2, consts: [["cdkDrag", "", 1, "side-panel", "order-1", "open", 3, "cdkDragDisabled", "top", "width", "side-panel-ai", "detached"], ["ycnTooltip", "", 1, "side-menu-toggler", 3, "click", "ngClass", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["ycnIcon", "", 3, "name"], [1, "side-menu", "order-2", 3, "ngClass"], [1, "side-menu-wrap"], [3, "jobsInProgress"], [1, "side-menu-item", "side-menu-item-close"], ["ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], [1, "side-menu-item"], ["data-test-id", "notifications-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["ycnIcon", "", 1, "use-color", 2, "opacity", "0", 3, "name"], ["ycnIcon", "", 1, "use-current", 3, "name"], [1, "badge", "bg-gray-base-95", "text-white", "ng-scope"], [1, "badge", "bg-yc-blue-ada", "text-white", "ng-binding", "ng-scope"], [1, "circle-progress", "circle-progress-sm"], ["data-test-id", "ai-agent-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["data-test-id", "quickflows-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["data-test-id", "workflows-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["cdkDrag", "", 1, "side-panel", "order-1", "open", 3, "cdkDragDisabled"], [1, "side-panel-wrap"], ["cdkDragHandle", "", 1, "side-panel-header", "bg-gray-base-90"], [1, "d-flex"], [1, "d-flex", "align-items-center"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "side-panel-toggler"], [1, "side-panel-content", 3, "displaySecurityId", "securityId", "securityName", "securityUrl"], [1, "side-panel-content", 3, "pagePath", "categories", "selectedSubcategoryId"], [1, "d-flex", "flex-column", "flex-auto", "overflow-auto", 3, "isDetached"], [1, "side-panel-content", "pl-12", "pr-12", "pb-12", "pt-12", 3, "notifications", "topSectionPercentage"], [1, "side-panel-title"], ["ycnTooltip", "", 1, "circle-progress", "ml-1", "cursor-pointer", 3, "tooltipTitle", "tooltipPlacement"], [1, "d-flex", "ml-auto"], ["href", "#", 3, "click"], [1, "divider-vertical", "mr-1", "ml-1"], ["ycnTooltip", "", 1, "circle-progress", "ml-1", "cursor-pointer", 3, "click", "tooltipTitle", "tooltipPlacement"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline", 3, "click"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent2", "btn-xs", "ml-1", 3, "href", "tooltipTitle"], ["ycnTooltip", "", "tooltipTitle", "Go To Full Page", 1, "btn", "btn-circle", "btn-transparent2", "btn-xs", "mr-1", "flex-none", 3, "href"], ["ycnIcon", "", "name", "icon-link-arrow"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent2", "btn-xs", "mr-1", "flex-none", 3, "click", "tooltipTitle"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "flex-none", "side-panel-toggler", 3, "click"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "side-panel-toggler", 3, "click"], [1, "side-panel-content", "pl-12", "pr-12", "pb-12", "pt-12", 3, "notificationsChange", "topSectionPercentageChange", "notifications", "topSectionPercentage"]], template: function SideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, SideMenuComponent_Conditional_0_Template, 12, 19);
        i0.ɵɵconditionalCreate(1, SideMenuComponent_Conditional_1_Template, 13, 18, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.USER().authenticated && (ctx.showQuickflows || ctx.showWorkflows && ctx.categories.length || ctx.showAgentButton() || ctx.showNotifications) ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefsLoaded() && ctx.isSidePanelOpen() ? 1 : -1);
    } }, dependencies: [i9.NgClass, i10.QuickflowsMenuComponent, i11.GuidedWorkflowsMenuComponent, i12.IconDirective, i13.TooltipDirective, i14.AgentSidePanelComponent, i15.CdkDrag, i15.CdkDragHandle, i16.NotificationsSideMenuComponent, i17.BackgroundJobsProgressPopoverComponent], styles: ["[_nghost-%COMP%] {\n                display: contents;\n            }\n\n            .detached[_ngcontent-%COMP%] {\n                position: fixed;\n                top: auto;\n                right: auto;\n                height: 80vh;\n                border-radius: 8px;\n                box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.3);\n                z-index: 1032;\n                overflow: hidden;\n\n                .side-panel-wrap {\n                    max-height: 100%;\n                    border-radius: 8px;\n                }\n            }"] });
